<!-- 页眉 -->
<template>
    <div class="top_header_box">
        <img :src="headerLogo" alt="" >
        <div class="line_box">
            <p>
                <img src="~@/assets/report2_imgs/icon_fc.png" alt="">
                {{title}}
            </p>
        </div>
    </div>
</template>
<script>
export default {
    name: 'top_header_box',
    components: {  },
    props: {
        headerLogo: {},
        title: {
            type: String,//
            // required: true
        },
    },
    data() {
        return {
            isShowLogo: false,
        }
    },
    watch: {
    },
    created() {
        if(document.domain=='zytb.chencaiwang.com'||document.domain=='ccjy.xuematech.com') {
            this.isShowLogo = true;
        }
    },
    mounted() {
    },
    methods: {
    }
}
</script>
<style type="text/css" lang='less' scoped>
.top_header_box {
    display: flex;
    height: 42px;
    margin-bottom: 40px;
    .log {
        display: block;
        height: 42px;
    }
    .line_box {
        padding-top: 20px;
        padding-bottom: 2px;
        flex: 1;
        border-bottom: 1px dashed #F6A837;
        p {
            line-height: 20px;
            float: right;
            display: flex;
            align-items: center;
            img {
                margin-right: 4px;
            }
        }
    }
}
</style>
